module.exports = __webpack_public_path__ + "media/Instruction_63.ac344fba.mp3";